export const getStoredParams = (location, getSessionStorageItem) => {
  const pathname = location.pathname.replace("/", "");
  return getSessionStorageItem(`${pathname}_filterParams`);
};
